// src/pages/ProfitLossReport/components/profitLossExportRows.js
// Maps the P&L table rows to the shared financial-report export rows (CSV / Excel).

export const toProfitLossExportRows = (rows) =>
  rows.map((r) => {
    switch (r.type) {
      case "sectionHeader":
        return { label: r.label, level: 0, style: "heading" };
      case "detail":
        return { label: r.label, level: 1, style: "detail", blankAfter: true };
      case "total":
        return { label: r.label, value: r.value, level: 0, style: "total", blankAfter: true };
      case "profit":
        return { label: r.label, value: r.value, level: 0, style: "grand", colorBySign: true };
      case "subRow":
      default:
        return { label: r.label, value: r.value, level: 1, style: "item" };
    }
  });
